import { defineMessages } from 'react-intl'

export default defineMessages({
    startDateLabel: {
        defaultMessage: 'Entrada',
    },
    startDatePlaceholder: {
        defaultMessage: 'Fecha Entrada',
    },
    endDateLabel: {
        defaultMessage: 'Salida',
    },
    endDatePlaceholder: {
        defaultMessage: 'Fecha Salida',
    },
    searchButtonTitle: {
        defaultMessage: 'Reservar',
    },
})
